var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-article row"},[(_vm.bzData.title)?_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.localized('title')))])]):_vm._e(),_vm._l((_vm.children),function(child){return _c(_vm.tagByModel(child[0]),{key:_vm.compoundKey.apply(void 0, child),tag:"component",attrs:{"id":child[1]}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a63c46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bz-tree/BzArticle.vue
// module id = 0WqY
// module chunks = 1